import { Router } from '@angular/router';
import { Component, OnInit, EventEmitter, Input, Output, Renderer, TemplateRef } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Pagination } from '../../../models/pagination';
import { Producto } from '../../../models/producto';
import { ProductoService } from '../../../services/producto.service';
import { FelectronicaService } from '../../../services/felectronica.service';
import { SessionService } from '../../../services/session.service';
import { SweetMessage } from '../../../config/sweet-message';

@Component({
	selector: 'reenviar-correo',
	templateUrl: './reenviar-correo.component.html',
	styleUrls: ['./reenviar-correo.component.css'],
	providers: [ProductoService, FelectronicaService]
})
export class ReenviarCorreoComponent implements OnInit {
    @Input() nombre: String;
	@Input() correo: String;
	@Input() autorizacion: String;
	public loading: boolean;
	public msg: SweetMessage;

	constructor(
		public felectronicaService:FelectronicaService,
		private ss: SessionService,
		public bsModalRef: BsModalRef,
		private modalService: BsModalService,
	) {
		this.loading = false;
		this.msg = new SweetMessage();
	}

	ngOnInit() {
		//
    }

    isValid(){
        return this.correo.toString().trim().length > 0;
    }
    
	onSubmit() {
		//envía de objecto producto
		//this.sendObject.emit(this.producto);
		//Cierre de modal o componente
		//this.bsModalRef.hide();
	}

	OnReenviar(){
		let data = {
			"clave": this.autorizacion,
			"correo": this.correo.toString(),
			"usuario_id": this.ss.getData('facelect_usuario_id')
		};
		this.loading = true;
		this.felectronicaService.ReenviarElectronica(data).subscribe(
			res => {
				this.loading = false;
				this.msg.showMessage('success-message', 'Se ha enviado el correo');
				this.bsModalRef.hide();
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message', "No se ha podido enviar el correo");
			}
		);
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/reenviar-correo/reenviar-correo.component.ts